import React from 'react';
import { TextInput, PasswordInput } from './Inputs';

const WiFiSettingsCard = ({
  wifiNumber,
  ssid,
  password,
  address,
  onSave,
  onChange,
}) => {
  return (
    <div className="bg-foreground shadow-md rounded-lg p-4 w-full">
      <h3 className="text-center text-secondary font-semibold mb-4">
        WiFi {wifiNumber}
      </h3>
      <TextInput
        label="SSID"
        value={ssid}
        onChange={(e) => onChange('username', e.target.value)}
        placeholder="SSID"
      />
      <PasswordInput
        label="Password"
        value={password}
        onChange={(e) => onChange('pw', e.target.value)}
        placeholder="Password"
      />
      <TextInput
        label="Address"
        value={address}
        onChange={(e) => onChange('address', e.target.value)}
        placeholder="Address"
      />
      <button
        className="bg-primary hover:bg-primary-dark text-foreground font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
        type="button"
        onClick={onSave}
      >
        Save
      </button>
    </div>
  );
};

export default WiFiSettingsCard;
